import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import {
  Box,
  CircularProgress,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import shape1 from "../../assets/admin/png/model-shape-1.png";
import shape2 from "../../assets/admin/png/model-shape-2.png";
import VSNImage from "../../shared/VSNImage";
import VSNModel from "../../shared/VSNModel";
import VSNTypography from "../../shared/VSNTypography";
import ViewWaiverMemberListModal from "./ViewWaiverMemberListModal";

const useStyles = makeStyles((theme) => ({
  heading: {
    position: "sticky",
    top: 0,
    borderBottom: "1px solid var(--primary)",
    padding: "12px 25px",
    margin: "0 -25px",
    backgroundColor: "var(--white)",
    zIndex: 2,
    [theme.breakpoints.down("sm")]: {
      padding: "12px 15px",
      margin: "0 -15px",
    },
    "&:after": {
      position: "absolute",
      content: "''",
      left: 0,
      right: 0,
      height: 25,
      width: "100%",
      bottom: "100%",
      background: "var(--white)",
      zIndex: 8,
    },
    "& svg": {
      borderRadius: "50%",
      [theme.breakpoints.down("md")]: {
        width: 40,
        height: 40,
      },
      [theme.breakpoints.down("sm")]: {
        width: 30,
        height: 30,
      },
    },
    "& h5": {
      fontSize: 24,
      fontWeight: 700,
      lineHeight: "31px",
      marginLeft: 16,
      [theme.breakpoints.down("md")]: {
        fontSize: 18,
        lineHeight: "26px",
        maxWidth: "70%",
      },
    },
  },
  shape: {
    position: "absolute",
    zIndex: -2,
  },
  shape1: {
    top: "20%",
    right: "10%",
  },
  shape2: {
    bottom: "5%",
    left: "0%",
  },
  vaiverFullView: {
    "&.MuiModal-root": {
      "& .MuiPaper-root": {
        maxWidth: "900px",
      },
    },
  },
}));

const WaiversStatusInfo = ({
  modelState,
  handleFetchWaivers,
  toggleModelShow,
}) => {
  const [downloadLoading, setDownloadLoading] = useState({});
  const dispatch = useDispatch();
  const classes = useStyles();
  const { WaiversListInfo, waiversStatusFormData } = useSelector(
    (state) => state?.api || {}
  );
  const { viewWaiverListModal: apiLoaders, fetchWaiverMemberList } =
    useSelector((state) => state?.api?.loader || {});

  const handleDocumentDownload = async (data) => {
    const waiverId = data?.name;
    setDownloadLoading((prev) => ({ ...prev, [waiverId]: true }));
    if (data?.path) {
      const fileName = "document.pdf";
      const link = document.createElement("a");
      link.href = data?.path;
      link.download = fileName;
      link.click();
      setDownloadLoading((prev) => ({ ...prev, [waiverId]: false }));
    } else {
      setDownloadLoading((prev) => ({ ...prev, [waiverId]: false }));
    }
  };

  return (
    <>
      <Box mb={4}>
        <>
          <VSNImage
            src={shape1}
            alt=""
            className={`${classes.shape} ${classes.shape1}`}
          />
          <VSNImage
            src={shape2}
            alt=""
            className={`${classes.shape} ${classes.shape2}`}
          />
          <Stack
            direction="row"
            alignItems="center"
            className={classes.heading}
          >
            <VSNTypography variant="h5" component="h5" my={1}>
              Waivers Status
            </VSNTypography>
          </Stack>
        </>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold" }}>Waivers Name</TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  Uploaded
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  Signature
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  View
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {apiLoaders ? (
                <TableCell colSpan={4} align="center">
                  <CircularProgress size={24} color="inherit" />
                </TableCell>
              ) : Array.isArray(WaiversListInfo) &&
                WaiversListInfo?.length > 0 ? (
                WaiversListInfo?.map((el, index) => (
                  <TableRow key={index}>
                    <TableCell>{el?.name ?? "-"}</TableCell>
                    <TableCell align="center">
                      {el?.is_uploaded ? (
                        <CheckCircleOutlineIcon style={{ color: "green" }} />
                      ) : (
                        <CancelOutlinedIcon style={{ color: "red" }} />
                      )}
                    </TableCell>
                    <TableCell>
                      <VSNTypography
                        sx={{
                          padding: "5px 10px",
                          borderRadius: 1.5,
                          width: "max-content",
                          backgroundColor:
                            el?.signature_status === "Signed"
                              ? "#F2FBF5"
                              : "#FFF8EB",
                          color:
                            el?.signature_status === "Signed"
                              ? "#34A259"
                              : "#F7A23B",
                        }}
                      >
                        {el?.signature_status}
                      </VSNTypography>
                    </TableCell>

                    <TableCell>
                      {el?.path ? (
                        <IconButton
                          sx={{ borderRadius: 1.5, backgroundColor: "#F2FBF5" }}
                          onClick={() => handleDocumentDownload(el)}
                          disabled={downloadLoading[el?.name]}
                        >
                          {downloadLoading[el?.name] ? (
                            <CircularProgress size={24} color="inherit" />
                          ) : (
                            <DownloadOutlinedIcon
                              style={{ color: "#34A259" }}
                            />
                          )}
                        </IconButton>
                      ) : el.signature_status === "Signed" ? (
                        <IconButton
                          color={
                            el.signature_status === "Signed"
                              ? "#8B3F9E"
                              : "#34A259"
                          }
                          sx={{
                            borderRadius: 1.5,
                            backgroundColor:
                              el?.signature_status === "Signed"
                                ? "#F2E7F5"
                                : "#F2FBF5",
                          }}
                          onClick={() => handleFetchWaivers(el)}
                        >
                          <VisibilityOutlinedIcon
                            style={{ color: "#8B3F9E" }}
                          />
                        </IconButton>
                      ) : (
                        "-"
                      )}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableCell colSpan={4} align="center">
                  No Waivers Found
                </TableCell>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      {modelState?.viewWaiverMemberListModal && (
        <VSNModel
          open={modelState?.viewWaiverMemberListModal}
          onClose={() => {
            dispatch(toggleModelShow("viewWaiverMemberListModal", true));
          }}
          disableEnforceFocus
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          mobileDrawer
          className={classes.vaiverFullView}
        >
          <ViewWaiverMemberListModal
            fetchWaiverMemberList={fetchWaiverMemberList}
            waiversStatusFormData={waiversStatusFormData}
          />
        </VSNModel>
      )}
    </>
  );
};

export default WaiversStatusInfo;
